import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminRamUser } from '../../../actions/managerListsActions';
import { MultiSelectFilter } from './MultiSelectFilter';
import { peopleOptions } from './peopleOptions';

/** DSO RAM manager filter. Writes the `dsoRamIds` filter key. */
export const DsoRAMFilter = ({ filter, handleFilterChange }) => {
  const dispatch = useDispatch();
  const dsoRAMManagers = useSelector((state) => state.users.dsoRAMManagers);

  useEffect(() => {
    if (!dsoRAMManagers) {
      dispatch(getAdminRamUser());
    }
  }, [dispatch, dsoRAMManagers]);

  return (
    <MultiSelectFilter
      label="DSO RAM Manager"
      options={peopleOptions(dsoRAMManagers)}
      value={filter?.dsoRamIds}
      onChange={(value) => handleFilterChange('dsoRamIds', value)}
      optionsWidth={250}
    />
  );
};

export default DsoRAMFilter;
